module.exports = __webpack_public_path__ + "media/img/square-logo-small-70f2c67129513757ee5888037c49aa92.png";